export default 
{
  "and": [
    {
      "==": [
        {
          "var": "autocomplete"
        },
        "jjj"
      ]
    },
    {
      "==": [
        {
          "var": "autocomplete"
        },
        "c"
      ]
    },
    {
      "all": [
        {
          "var": "autocompleteMultiple"
        },
        {
          "in": [
            {
              "var": ""
            },
            [
              "ggg",
              "jjjj",
              "aa",
              "b"
            ]
          ]
        }
      ]
    }
  ]
};
